<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container">
<img alt="Images" src="images/pub.jpg"/>
</div>
<h1 class="bktit"><a id="page_3"></a><span class="bold">SOG A PHOTO HISTORY OF THE SECRET WARS</span></h1>
<p class="author"><span class="bold">JOHN L. PLASTER</span></p>
<div class="img_container">
<img alt="Images" src="images/pub1.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?08fec1bc